import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./VehicleCard.css";

export default function VehicleCard({ title, imageSrc, href = "#", background }) {

    const { t } = useTranslation();

    return (
        <article
            className="vehicle-card"
            style={{
                background: background || "#121214"
            }}
        >
            <div className="vehicle-card__body">
                <h3 className="vehicle-card__title">{title}</h3>
                <div className="vehicle-card__media">
                    <img src={imageSrc} alt={title} className="vehicle-card__img" />
                </div>
                <div className="vehicle-card__link">
                    <Link to={href} >
                        {t("common.linkTitles.exploreNow")}
                    </Link>
                </div>

            </div>
        </article>
    );
}

